import { gql } from '@apollo/client'

export const DEMANDE_DEVIS_FOURNISSEURS_MUTATION = gql`
  mutation DemandeDevisFournisseurs($data: [d4_demandedevisfournisseur_insert_input!]!) {
    ddev: insert_d4_demandedevisfournisseur(objects: $data) {
      returning {
        id
        fournisseur_id
        demandedevis_id
        daterappel
      }
    }
  }
`
